<template>
  <div class="flex items-center justify-center min-h-screen bg-theme-bg2 p-4">
    <div class="w-full max-w-sm">
      <div class="bg-theme-card border border-theme-border rounded-2xl overflow-hidden">
        <div class="h-1 bg-gradient-to-r from-primary-600 to-secondary-500"></div>
        <div class="p-7">
          <div class="flex justify-center items-center mb-5">
            <img :src="isDark ? darkLogo : lightLogo" alt="logo" class="h-10 w-auto">
          </div>
          <div class="text-center mb-7">
            <h2 class="text-2xl font-bold text-theme-text">Reset Password</h2>
            <p class="text-sm text-theme-muted mt-1">Enter your email and we'll send a reset link</p>
          </div>
      <form @submit.prevent="requestPasswordReset">
        <div class="mb-4">
          <label for="email" class="block text-sm font-medium text-theme-text2">Email Address</label>
          <input
            type="email"
            id="email"
            v-model="email"
            required
            class="mt-1 block w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary-600 bg-theme-input text-theme-input-text border-theme-input-border"
            placeholder="Enter your email"
          />
        </div>
        <button
          type="submit"
          :disabled="loading"
          class="w-full bg-primary-600 text-white font-medium py-2 rounded-md hover:bg-primary-700 focus:ring-2 focus:ring-primary-600 focus:outline-none disabled:opacity-50"
        >
          {{ loading ? "Sending..." : "Request Reset Link" }}
        </button>
       
      </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useTheme } from '@/composables/useTheme.js';
import useNotifications from '@/store/notification';
import darkLogo from '@/assets/images/dark_logo.png';
import lightLogo from '@/assets/images/logo.jpeg';


export default {
  setup() {
    const { isDark } = useTheme();
    const email = ref("");
    const loading = ref(false);
    const api_base_url = import.meta.env.VITE_API_BASE_URL;
    const { showNotification } = useNotifications();

    const router = useRouter();


  
    const requestPasswordReset = async () => {
      loading.value = true;
      

      try {
        const response = await axios.post(
          `${api_base_url}/api/accounts/password-reset/send_reset_email/`,
          { email: email.value }
        );
        router.push({ name: 'home' });
        showNotification('Password Reset Request', `${response.data.message}` || "Reset link sent successfully!", 'success');

      } catch (err) {
        showNotification('Password Reset Request', `${err.response?.data?.error}` || "Failed to send reset link. Please try again.", 'error');

      } finally {
        loading.value = false;
      }
    };

    return {
      email,
      loading,
      isDark,
      darkLogo,
      lightLogo,
      requestPasswordReset,
    };
  },
};
</script>

<style scoped>
/* Add additional styling if necessary */
</style>
